'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    gtag?: (
      command: 'event' | 'config',
      eventName: string,
      params?: Record<string, unknown>,
    ) => void;
  }
}

export default function ScrollDepthTracker() {
  useEffect(() => {
    // The actual scroll container is `.layout-main` (overflow:auto, height:100vh)
    // — window never scrolls, so listening on window misses every event. Fall
    // back to window only if the layout shell is absent (defensive).
    const target: HTMLElement | Window =
      document.querySelector<HTMLElement>('.layout-main') ?? window;

    let fired75 = false;
    const onScroll = () => {
      if (fired75) return;
      const el =
        target instanceof Window ? document.documentElement : (target as HTMLElement);
      const scrolled = el.scrollTop + el.clientHeight;
      const total = el.scrollHeight;
      if (total <= el.clientHeight) return;
      if (scrolled / total >= 0.75) {
        fired75 = true;
        window.gtag?.('event', 'scroll_75', {
          page_path: location.pathname + location.search,
        });
        target.removeEventListener('scroll', onScroll);
      }
    };
    target.addEventListener('scroll', onScroll, { passive: true });
    return () => target.removeEventListener('scroll', onScroll);
  }, []);
  return null;
}
